module.exports = __webpack_public_path__ + "img/Trucking.a3753cd3.svg";